/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveReentrancyTest,
  CurveReentrancyTestInterface,
} from "../CurveReentrancyTest";

const _abi = [
  {
    inputs: [],
    name: "ExpectedToBeNotLockedButItIsLocked",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "PoolIsLockedOnReceive",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_provider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountToken",
        type: "uint256",
      },
    ],
    name: "exec",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "pool",
    outputs: [
      {
        internalType: "contract ICurveSTETHPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "provider",
    outputs: [
      {
        internalType: "contract CurveReentrancyCheck",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type CurveReentrancyTestConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveReentrancyTestConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveReentrancyTest__factory extends ContractFactory {
  constructor(...args: CurveReentrancyTestConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveReentrancyTest";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveReentrancyTest> {
    return super.deploy(overrides || {}) as Promise<CurveReentrancyTest>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): CurveReentrancyTest {
    return super.attach(address) as CurveReentrancyTest;
  }
  connect(signer: Signer): CurveReentrancyTest__factory {
    return super.connect(signer) as CurveReentrancyTest__factory;
  }
  static readonly contractName: "CurveReentrancyTest";
  public readonly contractName: "CurveReentrancyTest";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveReentrancyTestInterface {
    return new utils.Interface(_abi) as CurveReentrancyTestInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveReentrancyTest {
    return new Contract(address, _abi, signerOrProvider) as CurveReentrancyTest;
  }
}
